<template>
    <div class="wl-container">
        <NewComments :messageType="messageType" :siteId="siteId" v-if="false"></NewComments>
        <div class="wl-content-container content-with-comments">
            <template>
                <!--  tabs-->
                <div class="tab-row">
                    <ul class="tab-cls">
                        <li :class="activeTab === '1' ? 'active' : ''" @click="activeChange('1')">{{ $t('PAGE_EXCHANGE_TAB2') }}</li>
                        <li :class="activeTab === '2' ? 'active' : ''" @click="activeChange('2')">{{ $t('PAGE_EXCHANGE_TAB3') }}</li>
                    </ul>
                    <div class="btn">
                        <span :class="['clear-filter', cleanActive ? 'clear-filter-active' : '']" @click="clearAll">
                            <img src="@/assets/img/icon-screen.svg" class="table-setting-icon" />
                            {{ $t('clear_filter') }}
                        </span>
                    </div>
                </div>
                <!-- 按钮行 -->
                <div class="bar-row">
                    <div class="left">
                        <el-button
                            @click="toogleMultiSelect('download')"
                            :disabled="!hasPermission('download') || (chooseable && !!multiChoose.mode)"
                            icon="el-icon-download"
                            class="wl-green"
                        >
                            {{ $t('BATCH_DOWNLOAD') }}
                        </el-button>
                        <el-button
                            @click="toogleMultiSelect('delete')"
                            :disabled="chooseable && !!multiChoose.mode"
                            v-if="activeTab == 2 && !isComponentMember && isKpmgUser()"
                            class="wl-green svg-btn"
                        >
                            <img src="@/assets/img/icon-batchdeletion.svg" width="100%" class="btn-icon" />
                            {{ $t('patch_delete') }}
                        </el-button>
                        <el-button
                            @click="toogleMultiSelect('delete')"
                            :disabled="chooseable && !!multiChoose.mode"
                            v-if="activeTab == 1 && isKpmgUser()"
                            class="wl-green svg-btn"
                        >
                            <img src="@/assets/img/icon-batchsetting.svg" width="100%" class="btn-icon" />
                            {{ $t('patch_methods') }}
                        </el-button>
                    </div>
                    <div class="wl-search-bar">
                        <el-tooltip class="item" effect="dark" placement="bottom">
                            <div slot="content" style="width: 590px" v-html="$t('JOINT_WORKING_ADD_TIPS')" />
                            <span>
                                <el-button
                                    icon="el-icon-plus"
                                    @click="toggleAddVisible"
                                    v-if="isKpmgUser() && !(activeTab == '1' && isComponentMember)"
                                    :disabled="!(kpRoleBind && kpRoleBind.length > 0)"
                                    class="wl-green mgr10"
                                    >{{ $t('COMMON_ADD') }}
                                </el-button>
                            </span>
                        </el-tooltip>
                        <el-button
                            @click="toogleMultiSelect('email')"
                            :disabled="chooseable && !!multiChoose.mode"
                            v-if="isKpmgUser() && !(activeTab == '1' && isComponentMember) && !(activeTab == '2')"
                            class="wl-green"
                            icon="el-icon-message"
                        >
                            {{ $t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${activeTab}`) }}
                        </el-button>
                        <el-button
                            icon="el-icon-setting"
                            v-if="activeTab === '1' && !(activeTab == '1' && isComponentMember)"
                            @click="toggleDuedayAlarmVisible"
                            class="wl-green template-uploader"
                            >{{ $t('SET_DUEDAYALARM') }}
                        </el-button>
                        <el-button @click="exportList" :disabled="!hasPermission('download')" class="wl-green svg-btn">
                            <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                            {{ $t('Export_exchange_Items') }}
                        </el-button>
                        <el-button
                            @click="toogleMultiSelect('export')"
                            :disabled="!hasPermission('download') || (chooseable && !!multiChoose.mode)"
                            class="wl-green svg-btn"
                        >
                            <img src="@/assets/img/icon-export.svg" width="100%" class="btn-icon" />
                            {{ $t('BATCH_export') }}
                        </el-button>
                    </div>
                </div>

                <!-- 表格 -------------------------------start---------------->
                <div :class="['table-container-wrapper', chooseable ? 'show-table-bottom-operate' : '']">
                    <el-table
                        height="100%"
                        v-loading="loading"
                        :data="data"
                        @select-all="(e) => handleSelectAll(e, data)"
		                @select="handleSelect"
                        border
                        ref="exchangeTable"
                        class="exchange-table"
                        stripe
                    >
                        <el-table-column v-if="chooseable" align="center" type="selection" width="50"> </el-table-column>

                        <el-table-column
                            prop="entityName"
                            min-width="200"
                            v-if="activeTab != '2'"
                            :key="1"
                            show-overflow-tooltip
                            :label="$t('TABLE_HEAD_EntityList2')"
                        >
                        </el-table-column>

                        <el-table-column
                            :key="2"
                            prop="category"
                            min-width="150"
                            :align="activeTab === '2' ? 'center' : 'left'"
                            show-overflow-tooltip
                        >
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_Category') }}
                                    <MultiSelectPopver
                                        :hidePopperSearch="hidePopperSearch"
                                        :value.sync="searchForm.category"
                                        labelKey="label"
                                        valueKey="value"
                                        :inputFilterKey="['label', 'value']"
                                        :options="categoryOptions"
                                    ></MultiSelectPopver>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            :key="3"
                            prop="status"
                            width="200"
                            v-if="activeTab === '1'"
                            :label="$t('TABLE_HEADER_EXCHANGE_STATUS')"
                        >
                            <template slot="header" slot-scope="scope">
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_EXCHANGE_STATUS') }}
                                    <MultiSelectPopver
                                        :hidePopperSearch="hidePopperSearch"
                                        :value.sync="searchForm.statusList"
                                        labelKey="label"
                                        valueKey="value"
                                        :inputFilterKey="['label', 'value']"
                                        :options="statusOptions"
                                    ></MultiSelectPopver>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-select
                                    v-model="scope.row.status"
                                    @change="statusChange(scope.row)"
                                    :disabled="calcStatusCellDisabled(scope.row)"
                                    :class="'group_report_status_' + scope.row.status"
                                    style="position: relative;"
                                >
                                    <el-option
                                        v-for="item in statusOptions"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        :disabled="calcStatusOptionDisable(scope.row, item)"
                                    >
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>

                        <el-table-column :key="4" prop="dueDay" width="200" v-if="activeTab === '1'">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_DUEDAY') }}
                                    <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                        <template #reference>
                                            <div class="th-filter-down">
                                                <i
                                                    :class="['el-icon-arrow-down', searchForm.dueDay ? 'el-icon-arrow-down-active' : '']"
                                                ></i>
                                            </div>
                                        </template>
                                        <template>
                                            <el-date-picker
                                                class="input-with-select"
                                                :placeholder="$t('TABLE_HEADER_DUEDAY')"
                                                v-model="searchForm.dueDay"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                            >
                                            </el-date-picker>
                                        </template>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-date-picker
                                    style="width: 100%"
                                    :disabled="activeTab == '1' && isComponentMember"
                                    v-model="scope.row.dueDay"
                                    @change="dueDayChange(scope.row)"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                >
                                </el-date-picker>
                            </template>
                        </el-table-column>

                        <el-table-column :key="20" prop="confirmDueDay" width="200" v-if="activeTab === '1'">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_CONFIRM_DUEDAY') }}
                                    <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                        <template #reference>
                                            <div class="th-filter-down">
                                                <i
                                                    :class="['el-icon-arrow-down', searchForm.confirmDueDay ? 'el-icon-arrow-down-active' : '']"
                                                ></i>
                                            </div>
                                        </template>
                                        <template>
                                            <el-date-picker
                                                class="input-with-select"
                                                :placeholder="$t('TABLE_HEADER_CONFIRM_DUEDAY')"
                                                v-model="searchForm.confirmDueDay"
                                                value-format="yyyy-MM-dd"
                                                type="date"
                                            >
                                            </el-date-picker>
                                        </template>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-date-picker
                                    style="width: 100%"
                                    v-model="scope.row.confirmDueDay"
                                    @change="confirmDueDayChange(scope.row)"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                >
                                </el-date-picker>
                            </template>
                        </el-table-column>

                        <el-table-column :key="5" prop="chargeName" width="190" v-if="activeTab === '1'">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_KPUSER') }}
                                    <MultiSelectPopver
                                        :hidePopperSearch="hidePopperSearch"
                                        :value.sync="searchForm.chargeUserList"
                                        labelKey="xlabel"
                                        valueKey="id"
                                        :inputFilterKey="['xlabel', 'id']"
                                        :options="kpmgUserList.map((v) => ({ xlabel: v.userName + '(' + v.profitCenter + ')', ...v }))"
                                    ></MultiSelectPopver>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <el-select v-model="scope.row.chargeName" @change="changeKpmgUser(scope.row)" clearable filterable>
                                    <el-option
                                        v-for="item in kpmgUserList"
                                        :key="item.id"
                                        :label="item.userName + '(' + item.profitCenter + ')'"
                                        :value="item.id"
                                    >
                                    </el-option>
                                </el-select>
                            </template>
                        </el-table-column>
                        <el-table-column :key="6" prop="fileList" :width="activeTab === '1' ? 125 : 200" align="center">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEADER_fileNameList') }}
                                    <el-popover placement="bottom" trigger="click" :visible-arrow="false" @hide="hidePopperSearch">
                                        <template #reference>
                                            <div class="th-filter-down">
                                                <i
                                                    :class="[
                                                        'el-icon-arrow-down',
                                                        searchForm.searchContent ? 'el-icon-arrow-down-active' : ''
                                                    ]"
                                                ></i>
                                            </div>
                                        </template>
                                        <template>
                                            <el-input
                                                class="input-with-select"
                                                v-model="searchForm.searchContent"
                                                size="medium"
                                                :placeholder="$t('fileNameKeyword')"
                                                clearable
                                            ></el-input>
                                        </template>
                                    </el-popover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <span
                                    class="file-number-hint"
                                    @click="toogleFileDetailVisible(scope.row)"
                                    v-if="scope.row.fileList && scope.row.fileList.length > 0"
                                >
                                    {{ scope.row.fileList.length }}
                                </span>
                            </template>
                        </el-table-column>

                        <el-table-column :key="7" align="center" :width="activeTab === '1' ? 70 : 150" :label="$t('COMMON_UPLOAD')">
                            <template slot-scope="scope">
                                <i
                                    v-if="!isIE"
                                    :class="[
                                        'el-icon-upload',
                                        !hasPermission('upload') || (activeTab == '1' && !['1', '3'].includes(scope.row.status))
                                            ? 'wl-icon-messageBoardNull'
                                            : 'wl-icon-messageBoard'
                                    ]"
                                    @click="toogleUploadVisible(scope.row)"
                                ></i>
                                <el-button
                                    v-else
                                    @click="toogleUploadVisible(scope.row)"
                                    size="mini"
                                    :disabled="!hasPermission('upload') || (activeTab == '1' && !['1', '3'].includes(scope.row.status))"
                                    :class="[
                                        'el-icon-upload',
                                        !hasPermission('upload') || (activeTab == '1' && !['1', '3'].includes(scope.row.status))
                                            ? 'upload-forbid'
                                            : 'wl-green'
                                    ]"
                                    >{{ $t('COMMON_UPLOAD') }}</el-button
                                >
                            </template>
                        </el-table-column>

                        <el-table-column :width="activeTab === '1' ? 100 : 180" align="center" :label="$t('TABLE_HEAD_COMMENTS')" :key="8">
                            <template #header>
                                <div class="header-with-popup">
                                    {{ $t('TABLE_HEAD_COMMENTS') }}
                                    <DatePickerPopover
                                        :value.sync="searchForm.commentDate"
                                        :hidePopperSearch="hidePopperSearch"
                                    ></DatePickerPopover>
                                </div>
                            </template>
                            <template slot-scope="scope">
                                <div class="flex  item-center justify-center">
                                <i
                                  :class="[
                                      scope.row.messageNum > 0 ? 'wl-icon-messageBoard' : 'wl-icon-messageBoardNull',
                                      'el-icon-s-comment'
                                  ]"
                                  @click="toogleMessageBoardVisible(scope.row)"
                              ></i>
                              <span v-if="scope.row.todayCommentCount"> 
                                    <span class="message-today">{{ scope.row.todayCommentCount }}</span>
                                    <span>/</span> 
                              </span>
                              <span v-if="scope.row.messageNum > 0"> {{ scope.row.messageNum }}</span>
                            </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            :key="9"
                            :width="activeTab === '1' ? 90 : 170"
                            v-if="isKpmgUser() && !(activeTab == '1' && isComponentMember)"
                            align="center"
                            :label="$t('TABLE_HEADER_Action')"
                        >
                            <template slot-scope="scope">
                                <div>
                                    <i class="el-icon-edit-outline wl-icon-edit" @click="onEdit(scope.row)"></i>
                                    <i style="margin-left: 10px" class="el-icon-delete wl-icon-delete" @click="onDelete(scope.row)"></i>
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column
                            :key="10"
                            width="125"
                            v-if="activeTab === '1'"
                            align="center"
                            :label="$t('TABLE_HEADER_MODIFY_RECORD')"
                        >
                            <template slot-scope="scope">
                                <i class="el-icon-document-copy wl-icon-record" @click="getModifyRecord(scope.row)" />
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="footer-btn" v-if="chooseable">
                    <el-button class="cancel-btn" @click="cancelChoose" :disabled="!chooseable">
                        {{ $t('btn_cancel') }}
                    </el-button>
                    <el-button
                        @click="tooglebatchDownLoad('download')"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        class="wl-green"
                        v-if="chooseable && multiChoose.mode == 'download'"
                    >
                        {{ $t('COMMON_DOWNLOAD') }}
                    </el-button>
                    <el-button
                        @click="toogleEmailVisible"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        v-if="isKpmgUser() && !(activeTab == '1' && isComponentMember) && chooseable && multiChoose.mode == 'email'"
                        class="wl-green"
                    >
                        {{ $t(`PAGE_CLIENTUSER_EMAIL_EXCHANGE_TAB${activeTab}`) }}
                    </el-button>
                    <el-button
                        @click="onBatchDelete"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        v-if="isKpmgUser() && !(activeTab == '1' && isComponentMember) && chooseable && multiChoose.mode == 'delete'"
                        class="wl-green"
                    >
                        {{ $t('COMMON_DELETE') }}
                    </el-button>
                    <el-button
                        @click="tooglebatchDownLoad('export')"
                        :disabled="chooseable && hasSelectedList.length == 0"
                        class="wl-green"
                        v-if="chooseable && multiChoose.mode == 'export'"
                    >
                        {{ $t('BATCH_export') }}
                    </el-button>

                    <el-button
                        v-if="activeTab == '1' && multiChoose.mode == 'delete'"
                        @click="openbatchStatusChange($t('EXCHANGE_BATCH_STATUS'), 0)"
                        :disabled="emailBtnDisabled"
                        class="wl-green"
                    >
                        {{ $t('EXCHANGE_BATCH_STATUS') }}
                    </el-button>
                    <el-button
                        v-if="activeTab == '1' && !isComponentMember && multiChoose.mode == 'delete'"
                        @click="openbatchStatusChange($t('EXCHANGE_BATCH_DEADLINE'), 1)"
                        :disabled="emailBtnDisabled"
                        class="wl-green"
                    >
                        {{ $t('EXCHANGE_BATCH_DEADLINE') }}
                    </el-button>
                    <el-button
                        v-if="activeTab == '1' && multiChoose.mode == 'delete'"
                        @click="openbatchStatusChange($t('EXCHANGE_BATCH_KPUSER'), 2)"
                        :disabled="emailBtnDisabled"
                        class="wl-green"
                    >
                        {{ $t('EXCHANGE_BATCH_KPUSER') }}
                    </el-button>
                </div>
                <!------------------表格------------------------end-------------->
                <!-- 分页 -->
                <el-pagination
                    class="wl-pagination"
                    :current-page="pagination.pageNum"
                    :page-size="pagination.pageSize"
                    @current-change="onCurrentPageChange"
                    @size-change="onSizeChange"
                    layout="prev, pager, next, slot, total"
                    :total="pagination.total"
                >
                    <span>
                        <el-select v-model="pagination.pageSize" @change="onSizeChange">
                            <el-option v-for="item in pageOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                        </el-select>
                    </span>
                </el-pagination>
            </template>
        </div>
        <dashboard
            v-show="activeTab !== '2'" 
            ref="dashboard"
            :dashboardData="dashboardData"
            :pieLoading="pieLoading"
            :dashboardTableLoading="dashboardTableLoading"
            @chooseState="chooseState"
            @chooseTab="getPbcDrawerTable"
        />
        <!-- 新增/编辑的弹框 -->
        <exchange-add
            v-if="addVisible"
            :activeTab="activeTab"
            :saveLoading="btnLoading"
            :initData="initData"
            :onCancel="toggleAddVisible"
            :onAdd="saveEntityCategory"
        />
        <!-- email-->
        <exchange-email v-if="addVisibleEmail" :saveLoading="emailBtnLoading" :onCancel="toogleEmailVisible" :onAdd="sendEmail" />
        <!--upload弹窗-->
        <upload
            v-if="uploadVisible"
            :initData="rowData"
            :onCancel="closeUploadVisble"
            :onAdd="uploadSuccess"
            :isComponentMember="isComponentMember"
        />
        <!--        留言-->
        <messageBoard v-if="messageBoardVisible" :initData="rowData" :onCancel="toogleMessageBoardVisible" :onAdd="getTableList" :siteId="siteId" :messageType="messageType"/>
        <!--        文件详情-->
        <file-detail
            v-if="fileDetailVisbile"
            :id="rowData.id"
            :tableData="rowData.fileList"
            :curUserName="curUserName"
            :downloadAble="downloadAble"
            :onCancel="toogleFileDetailVisible"
            @on-file-download="downloadFileDetail"
            :isComponentMember="isComponentMember"
        />
        <!--        下载确认-->
        <file-confirm-modal
            :fileDownloading="fileDownloading"
            ref="FileConfirmModal"
            :groupList="hasSelectedList"
            @ok="downloadMultipleFiles"
            @on-file-download="downloadFileDetail"
            @updateMultipleSelection="updateMultipleSelection"
            :curUserName="curUserName"
            :downloadAble="downloadAble"
            :mode="downloadDialogMode"
            :isComponentMember="isComponentMember"
        />
        <!--        右侧抽屉-->
        <entity :onAdd="onDrawClick" :entityData="entityData" ref="entityRef" v-show="activeTab != '2'" />
        <!--        定制自动提醒频率-->
        <dueday-alarm v-if="duedayAlarmVisible" :onCancel="toggleDuedayAlarmVisible" />

        <modify-record v-if="recordVisible" :statusModifyTable="statusModifyTable" :onCancel="toggleRecordVisible" />

        <batch-change
            v-if="batchChangeVisible"
            :title="batchChangeTitle"
            :changeType="batchChangeElement"
            :batchChangeLoading="batchChangeLoading"
            :statusOptions="statusOptions"
            :kpmgUserList="kpmgUserList"
            :on-cancel="closeBatchChange"
            :onChange="batchChange"
        />
    </div>
</template>

<script>
import allCategory from '../exchange/allCategory'
import windowConfig from '@/utils/windowConfig'
import { mapGetters } from 'vuex'
import API from '@/api'
import { userPermission } from '@/mixins/userPermission.js'
import dashboardMixins from './dashboardMixins'
import batchSelectTableMixins from '@/mixins/batchSelectTableMixins.js'
import { formatFileSize, isIE, loading, dateFormat } from '@/utils'
import MultiSelectPopver from '@/components/common/MultiSelectPopver.vue'
import exchangeAdd from './exchange-add'
import Dashboard from './dashboard'
import exchangeEmail from './exchange-email'
import upload from './upload'
import fileDetail from './file-detail'
import FileConfirmModal from './file-confirm-modal'
import Entity from './entity'
import duedayAlarm from './duedayAlarm'
import modifyRecord from './modifyRecord'
import batchChange from './batch-change'
import messageBoard from './messageBoard'
import { exportFileLogXls } from '@/utils/exportTable'
import { downloadSingleFile, downloadBatchFiles } from '@/utils/useDownload'
import { treeToList } from '@/utils/formatTree'
import NewComments from '@/components/common/NewComments.vue'
import DatePickerPopover from '@/components/common/DatePickerPopover.vue'

export default {
    name: 'index',
    components: {
        MultiSelectPopver,
        exchangeAdd,
        exchangeEmail,
        upload,
        fileDetail,
        FileConfirmModal,
        Entity,
        duedayAlarm,
        modifyRecord,
        batchChange,
        messageBoard,
        NewComments,
        DatePickerPopover,
        Dashboard
    },
    data() {
        return {
            pageOptions: [
                { label: '10/' + this.$t('page') + this.$t('page_tip'), value: 10 },
                { label: '50/' + this.$t('page'), value: 50 },
                { label: '100/' + this.$t('page'), value: 100 }
            ],
            searchForm: {
                category: [],
                statusList: [],
                dueDay: null,
                confirmDueDay: null,
                chargeUserList: [],
                searchContent: '',
                commentDate: []
            },
            optionLoading: false,
            categoryOptions: [],
            chooseable: false,
            activeTab: '1',
            entityData: [],
            allEntityIds: [],
            data: [],
            downloadDialogMode: '', // download | export
            pagination: {
                pageNum: 1,
                pageSize: 10,
                total: 0
            },
            loading: false,
            btnLoading: false,
            addVisible: false,
            emailBtnLoading: false,
            addVisibleEmail: false,
            emailBtnDisabled: true,
            uploadVisible: false,
            messageBoardVisible: false,
            fileDetailVisbile: false,
            rowData: {},
            initData: {}, //编辑/新增传递参数
            fileDownloading: false,
            statusOptions: [],
            kpmgUserList: [],
            duedayAlarmVisible: false,
            recordVisible: false,
            statusModifyTable: [],
            curUserName: '',
            downloadAble: false,
            isComponentMember: false,
            batchChangeTitle: '',
            batchChangeElement: 0, //0--status, 1--deadline, 2---responsible
            batchChangeVisible: false,
            batchChangeLoading: false,
            kpRoleBind: [], //当前kp人员有无绑定角色信息
            multiChoose: {
                /* 是否可多选的状态在上层 */
                /* 已选中的数组在上层 */
                mode: '' // download | email
            },
            allCategory: allCategory,
            isIE: false
        }
    },
    mixins: [userPermission, dashboardMixins, batchSelectTableMixins],
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite',
            getEntityIds: 'getEntityIds'
        }),
        entityDataTotalSize(){
            const flatTree = treeToList(this.entityData).filter(item=>!item.disabled)
            return flatTree.length
        },
        cleanActive() {
            return (
                (this.searchForm.category && this.searchForm.category.length > 0) ||
                (this.searchForm.statusList && this.searchForm.statusList.length > 0) ||
                (this.searchForm.dueDay && this.searchForm.dueDay.length > 0) ||
                (this.searchForm.confirmDueDay && this.searchForm.confirmDueDay.length > 0) ||
                (this.searchForm.chargeUserList && this.searchForm.chargeUserList.length > 0) ||
                (this.searchForm.searchContent && this.searchForm.searchContent.length > 0) ||
                (this.getEntityIds.length!==this.entityDataTotalSize) ||
                (this.searchForm.commentDate && !!this.searchForm.commentDate[0])
            )
        },
        messageType() {
            return this.activeTab === '1'? '3':'4'
        },
        siteId() {
            return this.getSite.siteId
        }
    },
    watch: {
        hasSelectedList(newVal, oldVal) {
            this.emailBtnDisabled = newVal.length <= 0
        }
    },
    async mounted() {
        await this.getIfComponentMember()
        if (this.getUser.userType === '1') {
            this.getKpRolesBind()
        }
        await this.selectStatus()
        await this.selectKPOwner()
        await this.getUserEntity()
        await this.getTableList()
        await this.queryLimits()
        await this.getCategoryOptions()
        this.isIE = isIE()
    },
    methods: {
        hidePopperSearch() {
            this.pagination = {
                pageNum: 1,
                pageSize: 10,
                total: 0
            }
            this.getTableList()
        },
        exportList() {
                let params = {
                siteId: this.getSite.siteId,
                allEntityIdList: this.getEntityIds,
                entityIdList: this.getEntityIds,
                onlyKpmg: this.activeTab,
                ...this.pagination,
                ...this.searchForm
            }
            const _loading = loading()
            _loading.download()
            API.exchange
                .exportList(params)
                .then((res) => {
                    if (/application\/json/.test(res.data.type)) {
                        let reader = new FileReader()
                        reader.onload = (e) => {
                            if (e.target.readyState === 2) {
                                let resJson = {}
                                resJson = JSON.parse(e.target.result)
                                this.$message.error({ duration: 5000, message: this.$t(resJson.code) })
                            }
                        }
                        reader.readAsText(res.data)
                    }
                    if (/application\/octet-stream/.test(res.data.type)) {
                        let blob = new Blob([res.data])
                        const filename = decodeURI(res.headers['content-disposition'].replace('attachment; filename=', ''))
                        if (isIE()) {
                            navigator.msSaveBlob(blob, filename)
                        } else {
                            let url = window.URL.createObjectURL(blob)
                            let link = document.createElement('a')
                            link.style.display = 'none'
                            link.href = url
                            link.setAttribute('download', filename)
                            document.body.appendChild(link)
                            link.click()
                        }
                    }
                })
                .catch((e) => {})
                .finally(() => {
                    _loading.close()
                })
        },
        calcStatusOptionDisable(row, item) {
            // 5. Group auditor:
            // 当状态为4时，则不可再更改不其他状态。

            // Component (can do)
            // a. 1>2
            // b. 3>1
            // c. 3>2

            // Component (can’t do):
            // d. 1>3
            // e. 1>4
            // f. 2>ANY (也就是说状态为2 ‘已提交给集团项目组’的时候，则component不可以再动)
            // g. 3>4
            // h. 4>ANY (也就是说状态为4‘集团项目组已审阅’的时候，则component不可以再动)
            if (this.isComponentMember) {
                if (
                    (row.status == '1' && item.value == '3') ||
                    (row.status == '1' && item.value == '4') ||
                    row.status == '2' ||
                    (row.status == '3' && item.value == '4') ||
                    row.status == '4'
                ) {
                    return true
                } else {
                    return false
                }
            } else {
                if (row.status == '4') {
                    return true
                } else {
                    return false
                }
            }
        },
        onBatchDelete() {
            this.$confirm(this.$t('msg_delete_sure'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            }).then(() => {
                this.loading = true
                API.exchange
                    .batchDelete({
                        ids: this.hasSelectedList.map((v) => `${v.id}`)
                    })
                    .then((res) => {
                        if (res.code == '1') {
                            this.pagination.pageNum = 1
                            this.getTableList()
                            this.$message({
                                type: 'success',
                                message: this.$t('msg_success')
                            })
                            this.$refs.exchangeTable.clearSelection()
                            this.chooseable = false
                        } else {
                            this.$message.error(this.$t(res.code))
                        }
                    })
                    .catch((e) => {
                        console.error(e)
                        this.$message.error(this.$t('SYS_USER_003'))
                    })
                    .finally(() => {
                        this.loading = false
                        this.$refs.FileConfirmModal.visible = false
                        this.$refs.exchangeTable.clearSelection()
                        this.chooseable = false
                        this.$refs.exchangeTable.clearSelection()
                    })
            })
        },
        toogleMultiSelect(mode) {
            this.multiChoose = {
                mode: mode
            }
            this.chooseable = true
        },
        getKpRolesBind() {
            const params = {
                siteId: this.getSite.siteId,
                pageNum: 1,
                pageSize: 99999,
                queryParam: this.getUser.userName,
                userType: '1' //string 3 代表compoent/ 1代表member
            }
            API.kpTMember.queryMemberList(params).then((res) => {
                if (res.code === '1' && res.data.memberList && res.data.memberList.records && res.data.memberList.records.length > 0) {
                    this.kpRoleBind = res.data.memberList.records[0].roleIdList
                }
            })
        },
        async getIfComponentMember() {
            let params = {
                siteId: this.getSite.siteId,
                userId: this.getUser.userId
            }
            let { code, data } = await API.exchange.queryIfKpMember(params)
            if (code == '1') {
                this.isComponentMember = data.ifKpMember
                if (this.isComponentMember) this.activeTab = '1'
            }
        },
        async getCategoryOptions(query) {
            this.optionLoading = true
            let params = {
                category: query,
                siteId: this.getSite.siteId,
                onlyKpmg: this.activeTab
            }
            let { code, data } = await API.exchange.searchCategory(params)
            if (code == '1') {
                this.categoryOptions =
                    data.map((v) => {
                        const findCategory = this.allCategory[Number(this.activeTab)].find((vv) => vv.realValue === v)
                        const label = !!findCategory ? this.$t(findCategory.value) : v
                        const value = !!findCategory ? findCategory.realValue : v
                        return {
                            label,
                            value
                        }
                    }) || []
                this.optionLoading = false
            }
        },
        cancelChoose() {
            this.$refs.exchangeTable.clearSelection()
            this.chooseable = false
        },
        // 查询当前站点downloadable
        async queryLimits() {
            const { code, data } = await API.clientUser.getSiteConfig({ param: this.getSite.siteId })
            if (code == '1') {
                this.downloadAble = !!data.downloadable
            } else {
                this.$message.error(this.$t(code))
            }
            // 当前文件uploadby
            let userType = this.getUser.userType
            if (userType == '1') {
                this.curUserName = this.getUser.userName
            } else {
                this.curUserName = this.getUser.userAccount
            }
        },
        async selectStatus() {
            try {
                const { data, code } = await API.exchange.queryStatus()
                if (code == '1') {
                    data.forEach((item) => {
                        switch (item.value) {
                            case '1':
                                item.label = this.$t('ECHANGE_STATUS._1')
                                break
                            case '2':
                                item.label = this.$t('ECHANGE_STATUS._2')
                                break
                            case '3':
                                item.label = this.$t('ECHANGE_STATUS._3')
                                break
                            case '4':
                                item.label = this.$t('ECHANGE_STATUS._4')
                                break
                        }
                    })
                    this.statusOptions = data
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        async selectKPOwner() {
            try {
                const { data, code } = await API.matterLogs.searchKpmgOwner({ siteId: this.getSite.siteId, searchContent: '' })
                if (code == '1') {
                    this.kpmgUserList = data
                    this.kpmgUserList.map((item) => {
                        if (item.userName === 'Blank') {
                            item.userName = this.$t('common_empty')
                            item.profitCenter = this.$t('common_empty')
                        }
                    })
                } else {
                    this.$message.error(this.$t(code))
                }
            } catch (e) {
            } finally {
            }
        },
        isKpmgUser() {
            return this.getUser.userType === '1'
        },
        // 页码
        onCurrentPageChange(val) {
            this.pagination.pageNum = val
            this.getTableList()
        },
        onSizeChange(val) {
            this.pagination.pageNum = 1
            this.pagination.pageSize = val
            this.getTableList()
        },
        activeChange(val) {
            this.activeTab = val
            this.searchForm = {
                category: [],
                statusList: [],
                dueDay: null,
                confirmDueDay: null,
                chargeUserList: []
            }
            this.chooseable = false
            this.getCategoryOptions()
            this.getTableList()
        },
        async clearAll() {
            this.searchForm = {
                category: [],
                statusList: [],
                dueDay: null,
                confirmDueDay: null,
                chargeUserList: [],
                commentDate: []
            }
            await this.getUserEntity()
            await this.getTableList()
        },
        queryParams() {
            return {
                siteId: this.getSite.siteId,
                allEntityIdList: this.getEntityIds,
                entityIdList: this.getEntityIds,
                onlyKpmg: this.activeTab,
                ...this.pagination,
                ...this.searchForm,
                category: this.searchForm.category ? this.searchForm.category : [],
                startCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[0] ? dateFormat(new Date(this.searchForm.commentDate[0]), 'yyyy-MM-dd') : null,
                endCommentDate: this.searchForm.commentDate && this.searchForm.commentDate[1] ? dateFormat(new Date(this.searchForm.commentDate[1]), 'yyyy-MM-dd') : null,
            };
        },
        // 获取表格信息
        async getTableList() {
            // 如果是kp组成部分人员 && general 中的集团审计小组 关闭 => 页面空白
            let params = this.queryParams()
            this.loading = true
            const { code, data } = await API.exchange.exchangeQuery(params)
            if (code === '1') {
                this.data = !data.records
                    ? []
                    : data.records.map((v) => {
                          const findCategory = this.allCategory[Number(this.activeTab)]
                              ? this.allCategory[Number(this.activeTab)].find((vv) => vv.realValue === v.category)
                              : null
                          v.category = !!findCategory ? this.$t(findCategory.value) : v.category

                          v.oriStatus = v.status
                          return v
                      })
                this.pagination.total = data.total
                // 回显已选中的
                this.handleEchoData('exchangeTable', this.data)
                if (this.activeTab === '1') {
                    this.getPieEcharts()
                    this.getPbcDrawerTable()
                }
            } else {
                this.$message.error(this.$t(code))
            }
            this.loading = false
        },
        // 初始获取右侧entity信息
        getUserEntity: async function () {
            const { code, data } = await API.common.queryUserEntity({ siteId: this.getSite.siteId, exchangeType: '0' ,menuId: '24' ,userType: this.getUser.userType })
            if (code == '1') {
                this.entityData = [data]
                this.allEntityIds = []
                this.getAllIds(this.entityData[0])
                this.$store.commit('common/setEntityIds', this.allEntityIds)
            } else {
                this.$message.error(this.$t(code))
            }
        },
        // 获取所有node的id && 默认选中
        getAllIds(data) {
            if (!data.disabled) {
                data.checked = true
                this.allEntityIds.push(data.id)
            }
            if (data.childEntity.length > 0) {
                data.childEntity.forEach((child) => this.getAllIds(child))
            }
        },
        // 新增
        toggleAddVisible() {
            this.initData = {}
            this.addVisible = !this.addVisible
        },
        // 编辑
        onEdit(row) {
            this.initData = row
            this.addVisible = !this.addVisible
        },
        // 新增---保存
        async saveEntityCategory(form) {
            if (form.id) {
                form.onlyKpmg = this.activeTab
                const { code, data } = await API.exchange.exchangeUpdate(form)
                try {
                    if (code == '1') {
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                } catch (e) {
                    this.$message.error(e)
                }
            } else {
                const params = {
                    siteId: this.getSite.siteId,
                    entityIdList: form.entityIdList,
                    onlyKpmg: this.activeTab,
                    category: form.category
                }
                const { code, data } = await API.exchange.exchangeAdd(params)
                try {
                    if (code == '1') {
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        this.$message.error(this.$t(code))
                    }
                } catch (e) {
                    this.$message.error(e)
                }
            }
            this.pagination.pageNum = 1
            await this.getTableList()
            await this.getCategoryOptions()
            this.addVisible = !this.addVisible
        },

        toggleDuedayAlarmVisible() {
            this.duedayAlarmVisible = !this.duedayAlarmVisible
        },

        // 删除
        onDelete(row) {
            this.$confirm(this.$t('msg_delete_sure'), this.$t('COMMON_TIP'), {
                confirmButtonText: this.$t('btn_confirm'),
                cancelButtonText: this.$t('btn_cancel'),
                type: 'warning',
                cancelButtonClass: 'cancel-btn',
                confirmButtonClass: 'wl-green'
            })
                .then(() => {
                    API.exchange.exchangeDel(row.id).then((res) => {
                        if (res.code == '1') {
                            this.$message.success(this.$t('msg_success'))
                        } else {
                            this.$message.error(this.$t(code))
                        }
                        this.getTableList()
                    })
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('CANCLE_OPERATION')
                    })
                })
        },
        // 获取修改记录
        async getModifyRecord(row) {
            const { code, data } = await API.exchange.queryStatusModify({
                referId: row.id,
                currentStatus: row.status,
                siteId: this.getSite.siteId
            })
            if (code == '1') {
                this.statusModifyTable = data
                this.toggleRecordVisible()
            } else {
                this.$message.error(this.$t(code))
            }
        },
        toggleRecordVisible() {
            this.recordVisible = !this.recordVisible
        },
        // upload
        toogleUploadVisible(row) {
            if (!this.hasPermission('upload') || (this.activeTab == '1' && !['1', '3'].includes(row.status))) {
                return
            }
            this.rowData = row
            this.uploadVisible = !this.uploadVisible
        },
        closeUploadVisble() {
            this.getTableList()
            this.uploadVisible = !this.uploadVisible
        },
        async uploadSuccess() {
            await this.getTableList()
            this.rowData = this.data.filter((item) => item.id === this.rowData.id)[0]
        },
        // 留言
        toogleMessageBoardVisible(row) {
            this.messageBoardVisible = !this.messageBoardVisible
            this.rowData = row
        },
        // send email
        toogleEmailVisible() {
            this.addVisibleEmail = !this.addVisibleEmail
        },
        async sendEmail(emailList, ccList) {
            var info = []
            this.hasSelectedList.forEach((item) => {
                let fileList = []
                if (item.fileList && item.fileList.length > 0) {
                    let len = item.fileList.length
                    item.fileList.forEach((fileItem) => {
                        fileList.push({ fileId: fileItem.fileId, fileName: fileItem.name })
                    })
                }
                info.push({
                    entityName: item.entityName,
                    category: item.category,
                    fileList: fileList,
                    status: item.status,
                    dueDay: item.dueDay,
                    confirmDueDay: item.confirmDueDay,
                    chargeName: item.chargeName
                })
            })
            let param = {
                siteEntityList: info,
                sendUserIdList: emailList,
                siteId: this.getSite.siteId,
                source: this.activeTab,
                ccUserIdList: ccList
            }
            const { code, data } = await API.exchange.sendEmail(param)
            if (code == '1') {
                this.$message.success(this.$t('msg_success'))
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            } else {
                this.$message.error(this.$t(code))
            }
            this.addVisibleEmail = !this.addVisibleEmail
        },
        // 文件详情
        toogleFileDetailVisible(row) {
            this.rowData = row
            this.fileDetailVisbile = !this.fileDetailVisbile
        },
        updateMultipleSelection(row) {
            this.hasSelectedList = row
        },
        openbatchStatusChange(title, ele) {
            this.batchChangeTitle = title
            this.batchChangeElement = ele
            this.batchChangeVisible = true
        },
        closeBatchChange() {
            this.batchChangeVisible = false
        },
        async batchChange(data) {
            this.batchChangeLoading = true
            let idList = []
            this.hasSelectedList.forEach((item) => {
                idList.push(item.id)
            })
            let res = null
            let params = {
                siteId: this.getSite.siteId,
                idList: idList,
                ...data
            }
            if (this.batchChangeElement == 0) {
                params.bindIdList = idList
                res = await API.exchange.changeStatus(params)
            } else if (this.batchChangeElement == 1) {
                res = await API.exchange.batchSetDeadline(params)
            } else {
                res = await API.exchange.batchSetResponsible(params)
            }
            this.batchChangeLoading = false
            if (res.code == '1') {
                this.$message.success(this.$t('msg_success'))
            } else {
                this.$message.error(res.errDetails)
            }
            this.getTableList()
            this.batchChangeVisible = false
        },
        // 下载
        downloadFileDetail(v) {
            if (v.length > 0) {
                const list = []
                v.forEach((i, n) => {
                    list.push({
                        id: i.id,
                        fileId: i.fileId,
                        siteEntityId: i.id,
                        siteId: this.getSite.siteId,
                        source: 'group',
                        fileName: i.name
                    })
                })
                if (list.length === 0) {
                    this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                    return
                }
                if (list.length === 1) {
                    this.downloadFileListSingle(list[0])
                }

                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },
        async downloadFileListSingle({ siteId, fileId, source, siteEntityId, fileName }) {
            try {
                this.fileDownloading = true
                const downRes = await API.pbc.checkDownloadRight({ siteId, source, siteEntityId })
                if (downRes.code === '1') {
                    const paramsdata = {
                        siteId,
                        id: siteEntityId,
                        tempToken: downRes.data,
                        fileId: fileId,
                        source
                    }
                    downloadSingleFile(paramsdata)
                }
            } catch (e) {
            } finally {
                this.fileDownloading = false
                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },

        // 批量下载页面
        tooglebatchDownLoad(mode) {
            this.downloadDialogMode = mode
            if (this.hasSelectedList.length > 0) {
                let list = []
                this.hasSelectedList.forEach((item) => {
                    if (item.fileList && item.fileList.length > 0) {
                        item.fileList.forEach((f) => {
                            if (
                                !(
                                    this.getUser.userType === '2' &&
                                    !this.downloadAble &&
                                    f.uploadBy &&
                                    f.uploadBy.indexOf('@') !== -1 &&
                                    f.uploadBy.indexOf(this.curUserName) == -1
                                )
                            ) {
                                list.push({
                                    rowId: item.id,
                                    fileName: f.name,
                                    fileId: f.fileId,
                                    bindId: item.id,
                                    siteId: this.getSite.siteId,
                                    source: 'group'
                                })
                            }
                        })
                    }
                })
                if (list.length === 0) {
                    this.$message.error(this.$t('FILE_LIST_EMPTY_ALERT'))
                    return
                } else if (list.length === 1) {
                    if (mode == 'download') {
                        this.downloadFileListSingle({
                            siteId: this.getSite.siteId,
                            fileId: list[0].fileId,
                            source: 'group',
                            siteEntityId: list[0].rowId
                        })
                    } else if (mode == 'export') {
                        this.$refs.FileConfirmModal.visible = true
                    }
                } else {
                    this.$refs.FileConfirmModal.visible = true
                }
            }
        },
        // 批量下载
        downloadMultipleFiles(rows) {
                if (this.downloadDialogMode == 'download') {
                if (rows.length === 1) {
                    const { rowId, name, fileId } = rows[0]
                    this.downloadFileListSingle({ siteId: this.getSite.siteId, fileId: fileId, source: 'group', siteEntityId: rowId })
                } else {
                    let size = 0
                    const list = rows.map((row) => {
                        size += parseInt(row.size || 0)
                        return {
                            siteEntityId: row.rowId,
                            siteId: this.getSite.siteId,
                            fileId: row.fileId,
                            source: 'group'
                        }
                    })
                    if (size > windowConfig.download.size) {
                        this.$confirm(
                            this.$t('largeSizeFileAlertContent', { size: formatFileSize(windowConfig.download.size) }),
                            this.$t('largeSizeFileAlertTitle'),
                            {
                                distinguishCancelAndClose: true,
                                showConfirmButton:false,
                                cancelButtonText: this.$t('btn_ok'),
                                cancelButtonClass: 'wl-green',
                            }
                        ).then(() => {
                            this.downloadBatchList({ list },size)
                        })
                    } else {
                        this.downloadBatchList({ list },size)
                    }
                }
            } else if (this.downloadDialogMode == 'export') {
                const fileName = `Group Reporting_${this.activeTab === '1'?'Deliverables Collection':'Shared Documents'}_files records@${dateFormat(new Date(), 'yyyyMMdd')}.xlsx`
                exportFileLogXls([
                    // 标题行
                    [
                        this.$t('TABLE_HEADER_entityList'),
                        this.$t('TABLE_HEAD_Category'),
                        this.$t('DOWNLOAD_FILE_NAME'),
                        this.$t('DOWNLOAD_SIZE'),
                        this.$t('DOWNLOAD_TIME'),
                        this.$t('DOWNLOAD_BY'),
                        this.$t('UPLOAD_TIME'),
                        this.$t('UPLOAD_BY'),
                        this.$t('HISTORY')
                    ],
                    ...rows.map((v) => {
                        return [
                            v.entityName ? v.entityName : '',
                            v.category ? v.category : '',
                            v.name ? v.name : '',
                            v.size ? formatFileSize(v.size) : '0',
                            v.downloadDate ? v.downloadDate : '',
                            v.downloadBy ? v.downloadBy : '',
                            v.uploadDate ? v.uploadDate : '',
                            v.uploadBy ? v.uploadBy : '',
                            v.hasHistory ? v.hasHistory : ''
                        ]
                    })
                ],fileName)

                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },
        //批量下载
        async downloadBatchList(params,size) {
            try {
                // this.fileDownloading = true
                const downRes = await API.exchange.checkBatchDownloadRight(params)
                if (downRes.code === '1') {
                    const fileIdList = params.list.map((item) => item.fileId).join(',')
                    const reqParams = {
                        token: downRes.data,
                        siteId: this.getSite.siteId,
                        fileIdList,
                        source: 'group'
                    }
                    this.$refs.FileConfirmModal.visible = false

                    downloadBatchFiles('/file/free/downloadExMultipleFilesAsZip', reqParams,size)
                } else {
                    this.$message.error(res.errDetails.msg)
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
                this.fileDownloading = false
                this.$refs.FileConfirmModal.visible = false
                this.$refs.exchangeTable.clearSelection()
                this.chooseable = false
            }
        },

        // 抽屉
        onDrawClick() {
            this.pagination.pageNum = 1
            this.getTableList()
        },

        // 计算状态单元格的禁用状态
        // 当状态为"已提交集团项目组"或“集团项目组已审阅”时，则Component member不可再更改状态;
        // 当状态为“集团项目组已审阅”时，则Group auditor也不可再更改状态，即双方均freeze.(即像PBC版块的"已完成"功能);
        calcStatusCellDisabled(row) {
            if (this.activeTab == '1' && this.isComponentMember && ['2', '4'].includes(row.status)) {
                return true
            }

            if (row.status == '4') {
                return true
            }

            return false
        },
        /**
         * 修改状态
         *
         * 对于在四种状态之间的更改限制，对Group auditor 和 Component auditor做以下限制：
         * - Group Auditor: 可以在1， 2， 3 之间随意更改，仅当状态更新为4时，弹框提示用户：该操作将不允许再修改，请确认！
         * - Component Audit: 仅允许操作以下状态："1 => 2"; "3 => 1"; "3 => 2"； 当状态更新为2时，弹框提示用户：该操作将不允许再修改，请确认！
         */
        async statusChange(row) {
            const newStatus = row.status
            row.status = row.oriStatus
            if (!this.isComponentMember && ['2', '4'].includes(newStatus)) {
                this.$confirm(this.$t(`confirm_not_editble_${newStatus}`), this.$t('COMMON_TIP'), {
                    showConfirmButton: true,
                    confirmButtonText: this.$t('btn_confirm'),
                    confirmButtonClass: 'wl-green',

                    showCancelButton: true,
                    cancelButtonText: this.$t('comment_reSet'),
                    cancelButtonClass: 'cancel-btn',

                    closeOnClickModal: false,
                    dangerouslyUseHTMLString: true,
                    type: 'warning'
                })
                    .then(async () => {
                        this.handleStatusChange(row, newStatus)
                    })
                    .catch((e) => {
                        row.status = row.oriStatus
                    })
            } else if (this.isComponentMember) {
                if (
                    (row.oriStatus == '1' && newStatus == '2') ||
                    (row.oriStatus == '3' && newStatus == '1') ||
                    (row.oriStatus == '3' && newStatus == '2')
                ) {
                    if (newStatus == '2') {
                        this.$confirm(this.$t('confirm_not_editble_2'), this.$t('COMMON_TIP'), {
                            showConfirmButton: true,
                            confirmButtonText: this.$t('btn_confirm'),
                            confirmButtonClass: 'wl-green',

                            showCancelButton: true,
                            cancelButtonText: this.$t('comment_reSet'),
                            cancelButtonClass: 'cancel-btn',

                            closeOnClickModal: false,
                            dangerouslyUseHTMLString: true,
                            type: 'warning'
                        })
                            .then(() => {
                                this.handleStatusChange(row, newStatus)
                            })
                            .catch((e) => {
                                row.status = row.oriStatus
                            })
                    } else {
                        this.handleStatusChange(row, newStatus)
                    }
                } else {
                    row.status = row.oriStatus
                    this.$message.error(this.$t('forbid_update_status'))
                }
            } else {
                this.handleStatusChange(row, newStatus)
            }
        },
        handleStatusChange(row, newStatus) {
            API.exchange
                .changeStatus({
                    bindIdList: [row.id],
                    status: newStatus,
                    siteId: this.getSite.siteId
                })
                .then((res) => {
                    if (res.code == '1') {
                        row.oriStatus = newStatus
                        row.status = newStatus
                        this.$message.success(this.$t('msg_success'))
                    } else {
                        row.status = row.oriStatus
                        this.$message.error(this.$t(res.code))
                    }
                })
        },
        async changeKpmgUser(row) {
            try {
                const res = await API.exchange.changeKpmgUser({ bindIdList: [row.id], userId: row.chargeName, userType: '1' })
                if (res.code == '1') {
                    const _cData = this.kpmgUserList.filter(v => v.id === row.chargeName)
                    if (_cData.length) {
                        row.chargeName = _cData[0].userName + '(' + _cData[0].profitCenter + ')'
                    }
                    this.$message.success(this.$t('msg_success'))
                } else {
                    this.$message.error(res.errDetails.msg)
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
            }
        },
        async dueDayChange(row) {
            try {
                const res = await API.exchange.changeDueDay({ bindIdList: [row.id], dueDayTime: row.dueDay })
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                } else {
                    this.$message.error(res.errDetails.msg)
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
            }
        },
        async confirmDueDayChange(row) {
            try {
                const res = await API.exchange.changeConfirmDueDay({ bindIdList: [row.id], dueDayTime: row.confirmDueDay })
                if (res.code == '1') {
                    this.$message.success(this.$t('msg_success'))
                } else {
                    this.$message.error(res.errDetails.msg)
                }
            } catch (e) {
                this.$message.error(e.message)
            } finally {
            }
        }
    }
}
</script>

<style scoped>
::v-deep .exchange-table .el-table__body-wrapper {
    height: calc(100% - 44px) !important;
}
.wl-container {
    height: 100%;
    background: #eff1f5;
    padding: 22px;
}

.wl-content-container {
    background: #fff;
    height: 100%;
    padding: 10px 22px;
    border-radius: 8px;
}
.tab-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    /* border-bottom: 1PX solid #e3e4e6; */
}
.clear-filter {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    font-size: 12PX;
}

.clear-filter img {
    margin-right: 5px;
}
.tab-cls {
    display: flex;
    list-style: none;
    justify-content: flex-start;
    align-items: flex-start;
    height: 38PX;
}
.tab-cls li {
    margin-right: 10px;
    background-color: #ccced2;
    height: 28PX;
    line-height: 28PX;
    border-radius: 14PX;
    color: #fff;
    font-size: 14px;
    padding: 0 30px;
    cursor: pointer;
}
.tab-cls li.active {
    background-color: #3879eb;
}
.GuidanceTooltip {
    margin-left: 5px;
}

.search-row,
.bar-row {
    height: 35PX;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
}
.search-row .el-button,
.bar-row .el-button {
    height: 30PX;
    border-radius: 5PX;
}
.left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
}
.search-item {
    margin-right: 20px;
    width: 260px;
}
.search-item .el-date-editor.el-input {
    width: 260px;
}

.wl-search-bar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
.ITA-container {
    height: calc(100% - 40PX);
}
.table-container-wrapper {
    margin-top: 5PX;
    height: calc(100% - 113PX - 49px);
}
.table-container-wrapper.show-table-bottom-operate {
    height: calc(100% - 113PX - 99px);
}
.wl-icon-messageBoard {
    font-size: 18px;
    color: #3879eb;
    cursor: pointer;
}

.wl-icon-messageBoardNull {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.upload-forbid {
    cursor: not-allowed;
}

.file-number-hint {
    display: block;
    margin-right: 10px;
    width: 100%;
    cursor: pointer;
    user-select: none;
    color: blue;
    text-decoration: underline;
}

.wl-icon-no-delete {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.wl-icon-no-edit {
    color: #c0c4cc;
    font-size: 18px;
    cursor: pointer;
}

.wl-icon-record {
    color: #1aa0a0;
    font-size: 18px;
    cursor: pointer;
}

.input-with-select {
    width: 260px;
    margin-right: 12px;
}

.wl-overflow-tooltip {
    overflow: hidden;
    display: inline-block;
    width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.template-uploader {
    margin-left: 10px;
}

.wl-green {
    height: 32px;
}
.mgr10 {
    margin-right: 10PX;
}
.footer-btn {
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}
::v-deep .el-pagination .el-select .el-input {
    width: 150px;
}
.header-with-popup {
    display: flex;
    flex-direction: row;
    justify-content: center;
}

::v-deep .group_report_status_1::before {
    content: '\e7a3';
    font-family: element-icons !important;
    position: absolute;
    font-size: 16px;
    top: 1px;
    left: 7px;
    color: #989898;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .group_report_status_2::before {
    content: "\e71f";
    font-family: element-icons !important;
    position: absolute;
    font-size: 16px;
    top: 1px;
    left: 7px;
    color: #1e49e2;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .group_report_status_3::before {
    content: "\e7a3";
    font-family: element-icons !important;
    position: absolute;
    font-size: 16px;
    top: 1px;
    left: 7px;
    color: #fd349c;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}
::v-deep .group_report_status_4::before {
    content: "\e79c";
    font-family: element-icons !important;
    position: absolute;
    font-size: 16px;
    top: 1px;
    left: 7px;
    color: #269924;
    z-index: 1;
    height: 100%;
    display: flex;
    align-items: center;
}

::v-deep .group_report_status_1 .el-input__inner {
    color: #989898 !important;
    padding-left: 25px !important;
}
::v-deep .group_report_status_2 .el-input__inner {
    color: #1e49e2 !important;
    padding-left: 25px !important;
}
::v-deep .group_report_status_3 .el-input__inner {
    color: #fd349c !important;
    padding-left: 25px !important;
}
::v-deep .group_report_status_4 .el-input__inner {
    color: #269924 !important;
    padding-left: 25px !important;
}
</style>
